<!-- 商品価格確認 -->
<template>
  <div>
    <HeaderComponent :isAdminPage="true" />
  </div>
  <div v-if="isInitError" id="com_form_contet_admin">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <div v-if="isDataFetched" class="com_form_contet_admin">
    <section class="com_sec1">
      <div class="inner1">
        <h2 class="title_left">商品価格確認</h2>
      </div>
      <!-- 文言表示 -->
      <ul class="notice-messages" v-if="noticeMessages.length">
        <li v-for="(msg, idx) in noticeMessages" :key="idx">
          {{ msg }}
        </li>
      </ul>
      <!-- エラーメッセージの表示エリア -->
      <div
        v-if="errorMessage"
        class="error-message"
        style="white-space: pre-wrap"
      >
        {{ errorMessage }}
      </div>
      <!-- 検索条件 -->
      <div class="">
        <table class="cond-table">
          <thead>
            <th style="width: 10%"></th>
            <th style="width: 23%"></th>
            <th style="width: 8%"></th>
            <th style="width: 23%"></th>
            <th style="width: 8%"></th>
            <th style="width: 23%"></th>
            <th style="width: 5%"></th>
          </thead>
          <tbody>
            <tr>
              <td class="cond-control-title">品番（SKU）</td>
              <td>
                <input
                  id="sku"
                  v-model="inputData.sku"
                  type="text"
                  placeholder="半角8桁で入力してください"
                  maxlength="9"
                  class="form-control"
                />
                <div class="cond-note">
                  ※ハイフンありでも検索可（0000-0000）
                </div>
              </td>

              <td class="cond-control-title">商品名</td>
              <td>
                <input
                  id="productName"
                  v-model="inputData.productName"
                  type="text"
                  placeholder="全角で入力してください"
                  maxlength="255"
                  class="form-control"
                />
                <div class="cond-note">&nbsp;</div>
              </td>

              <td class="cond-control-title">装置名</td>
              <td>
                <input
                  id="deviceName"
                  v-model="inputData.deviceName"
                  type="text"
                  placeholder="全角で入力してください"
                  maxlength="255"
                  class="form-control"
                />
                <div class="cond-note">&nbsp;</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- 検索、クリアボタン -->
      <div class="form-inline flex-container form1">
        <div class="form-group"></div>
        <div class="form-group" style="margin-left: 255px">
          <button
            type="button"
            name="btnSerch"
            class="button1 cond-btn-footer"
            @click="onSerch"
          >
            検索
          </button>
          <button
            type="button"
            name="btnClear"
            class="button1 cond-btn-footer"
            @click="onClear"
          >
            クリア
          </button>
        </div>
      </div>
      <hr style="margin: 5px" />
      <!-- 件数・ダウンロード -->
      <div class="result-header">
        <div class="counts">
          <span>件数：</span>
          <template v-if="productPriceList.length > 0">
            <span>{{ formatCount(productPriceList.length) }}</span>
          </template>
          <template v-if="selectedCount > 0">
            <span>出力件数：</span>
            <span>{{ formatCount(selectedCount) }}</span>
          </template>
        </div>

        <div class="download">
          <div class="radio-group">
            <label class="radio-item">
              <input
                type="radio"
                id="csv"
                name="downloadType"
                :value="ProductPriceCheckConstants.DOWNLOAD_TYPE_CSV"
                v-model="downloadType"
              />
              CSV形式
            </label>
            <label class="radio-item">
              <input
                type="radio"
                id="excel"
                name="downloadType"
                :value="ProductPriceCheckConstants.DOWNLOAD_TYPE_EXCEL"
                v-model="downloadType"
              />
              Excel形式
            </label>
          </div>

          <div class="form1">
            <button
              type="button"
              class="button1 btn-download"
              :disabled="productPriceList.length === 0"
              @click="onDownload"
            >
              <span class="icon" aria-hidden="true">
                <!-- 添付に近いダウンロードアイコン -->
                <svg
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <!-- 枠（下が空いてるコの字） -->
                  <path d="M4 16v4h16v-4" />
                  <!-- 矢印 -->
                  <path d="M12 4v10" />
                  <path d="M8 10l4 4 4-4" />
                </svg>
              </span>
              <span class="">選択した項目をダウンロード</span>
            </button>
          </div>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-list">
        <table class="table table-bordered result-table">
          <thead class="">
            <tr>
              <th class="col_selection form1">
                <button
                  type="button"
                  class="btn-select-header"
                  :disabled="paginatedData.length === 0"
                  @click="toggleSelectCurrentPage"
                >
                  {{ selectHeaderLabel }}
                </button>
              </th>
              <th class="col_sku">品番</th>
              <th class="col_productName">商品名</th>
              <th class="col_manufacturer">メーカー</th>
              <th class="col_retailPrice">希望小売価格</th>
              <th class="col_yourPrice">(A)貴社お渡し価格</th>
              <th class="col_logisticsFee">(B)物流代行料</th>
              <th class="col_total">(C)合計（A+B）</th>
              <th class="col_s3Price">S3価格</th>
              <th class="col_aPrice">A価格</th>
              <th class="col_bPrice">B価格</th>
              <th class="col_ePrice">E価格</th>
              <th class="col_priceRevision">価格改定<br />予定</th>
              <th class="col_endSchedule">終息予定</th>
              <th class="col_deviceName">装置名</th>
              <th class="col_remarks">備考</th>
            </tr>
          </thead>
          <tbody style="line-height: 1.2">
            <tr
              class="tr-row-data"
              v-for="item in paginatedData"
              :key="item.sku"
            >
              <td
                data-name="mSelection"
                class="col_selection cell-checkbox"
                @click="toggleSelection(item)"
              >
                <input
                  id="mSelection"
                  v-model="item.selection"
                  type="checkbox"
                  class="form-check-input"
                  @click.stop
                />
              </td>
              <td data-name="mSku" class="col_sku">
                <a
                  class="link-url"
                  :href="buildLinkCellForSku(item.sku).href!"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ buildLinkCellForSku(item.sku).text }}
                </a>
              </td>
              <td
                data-name="mProductName"
                class="col_productName"
                v-tooltip="item.productName"
              >
                {{ item.productName }}
              </td>
              <td
                data-name="mManufacturer"
                class="col_manufacturer"
                v-tooltip="item.manufacturer"
              >
                {{ item.manufacturer }}
              </td>
              <td
                data-name="mRetailPrice"
                class="col_retailPrice"
                :class="item.retailPriceOpenFlg === '1' ? '' : 'cell-number'"
              >
                {{ item.retailPrice }}
              </td>
              <td data-name="mYourPrice" class="col_yourPrice cell-number">
                {{ item.yourPrice }}
              </td>
              <td
                data-name="mLogisticsFee"
                class="col_logisticsFee cell-number"
              >
                {{ item.logisticsFee }}
              </td>
              <td data-name="mTotal" class="col_total cell-number">
                {{ item.total }}
              </td>
              <td data-name="mS3Price" class="col_s3Price cell-number">
                {{ item.s3Price }}
              </td>
              <td data-name="mAPrice" class="col_aPrice cell-number">
                {{ item.aPrice }}
              </td>
              <td data-name="mBPrice" class="col_bPrice cell-number">
                {{ item.bPrice }}
              </td>
              <td data-name="mEPrice" class="col_ePrice cell-number">
                {{ item.ePrice }}
              </td>
              <td
                data-name="mPriceRevision"
                class="col_priceRevision cell-date"
              >
                <template
                  v-if="
                    buildLinkCellForDate(
                      item.priceRevisionDate,
                      item.priceRevisionNoticeLinkUrl
                    ).href
                  "
                >
                  <a
                    class="link-url"
                    :href="buildLinkCellForDate(item.priceRevisionDate, item.priceRevisionNoticeLinkUrl).href!"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{
                      buildLinkCellForDate(
                        item.priceRevisionDate,
                        item.priceRevisionNoticeLinkUrl
                      ).text
                    }}
                  </a>
                </template>
                <template v-else>
                  {{ item.priceRevisionDate }}
                </template>
              </td>
              <td data-name="mEndSchedule" class="col_endSchedule cell-date">
                <template
                  v-if="
                    buildLinkCellForDate(item.endDate, item.endNoticeLinkUrl)
                      .href
                  "
                >
                  <a
                    class="link-url"
                    :href="buildLinkCellForDate(item.endDate, item.endNoticeLinkUrl).href!"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{
                      buildLinkCellForDate(item.endDate, item.endNoticeLinkUrl)
                        .text
                    }}
                  </a>
                </template>
                <template v-else>
                  {{ item.endDate }}
                </template>
              </td>
              <td
                data-name="mDeviceName"
                class="col_deviceName"
                v-tooltip="item.deviceName"
              >
                {{ item.deviceName }}
              </td>
              <td
                data-name="mRemarks"
                class="col_remarks"
                v-tooltip="item.remarks"
              >
                {{ item.remarks }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <content-pagination
        :current-page="currentPage"
        :total-pages="totalPages"
        :items-per-page="itemsPerPage"
        @page-changed="handlePageChange"
      />
    </section>
  </div>
  <div>
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop />
  <LoadingOverlayComponent v-if="isLoading" :lines="loadLines" />
</template>

<script lang="ts">
import {
  defineComponent,
  computed,
  onMounted,
  ref,
  watch,
  onBeforeUnmount,
} from "vue";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import ContentPagination from "../controls/ContentPagination.vue";
import {
  formatMessage,
  outputDebugLogs,
  isTokenAlive,
  sanitizeInput,
  hasNoGaiji,
  commonHandleAxiosError,
} from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import apiAuthClient from "@/util/apiClientAuth";
import messages from "@/assets/messages.json";
import BackToTop from "../controls/BackToTop.vue";
import { useUserStore } from "@/store/userStore";
import { useRouter } from "vue-router";
import { useProcessingStore } from "../../store/useProcessingStore";
import "vue-loading-overlay/dist/css/index.css";
import LoadingOverlayComponent from "../layout/LoadingOverlayComponent.vue";

interface InputData {
  sku: string; // 品番
  productName: string; // 商品名
  deviceName: string; // 装置名
}
interface ProductPriceData {
  selection: boolean; // 選択
  sku: string; // 品番
  productName: string; // 商品名
  manufacturer: string; // メーカー
  retailPrice: string; // 希望小売価格
  retailPriceOpenFlg: string; // 希望小売価格オープンフラグ
  yourPrice: string; // (A)貴社お渡し価格
  logisticsFee: string; // (B)物流代行料
  total: string; // (C)合計（A+B）
  s3Price: string; // S3価格
  aPrice: string; // A価格
  bPrice: string; // B価格
  ePrice: string; // E価格
  endFlg: string; // 終息済みフラグ
  priceRevisionDate: string; // 価格改定(予定)日
  priceRevisionNoticeLinkUrl: string; // 価格改定案内リンクURL
  endDate: string; // 終息(予定)日
  endNoticeLinkUrl: string; // 終息案内リンクURL
  deviceName: string; // 装置名
  remarks: string; // 備考
}

class ProductPriceCheckConstants {
  // ダウンロード形式
  static readonly DOWNLOAD_TYPE_CSV = "CSV"; // CSV形式
  static readonly DOWNLOAD_TYPE_EXCEL = "EXCEL"; // Excel形式

  // 最低入力文字数
  static readonly MIN_INPUT_LENGTH_PRODUCT_NAME = 2; // 商品名
  static readonly MIN_INPUT_LENGTH_DEVICE_NAME = 2; // 装置名
}

export default defineComponent({
  name: "ProductPriceCheckComponent",
  components: {
    HeaderComponent,
    FooterComponent,
    BackToTop,
    ContentPagination,
    LoadingOverlayComponent,
  },
  setup() {
    const router = useRouter();
    const isInitError = ref(true); // 初期表示時のエラーフラグ
    const processingStore = useProcessingStore();
    const { logoutUser } = useUserStore();
    const isDataFetched = ref(false); // データが取得済みかどうかを追跡
    const errorMessage = ref(""); // エラーメッセージ（キーワード検索の下のやつ）
    const isKaunetAdmin = ref(false); // カウネット管理者フラグ
    const agCode = ref(""); // AGコード
    const userId = ref(""); // ユーザーID
    const pseudoAgCode = ref(""); // 疑似ログインAGコード
    const pseudoUserId = ref(""); // 疑似ログインユーザーID
    const serchAgCode = ref(""); // 検索用AGコード
    const serchUserId = ref(""); // 検索用ユーザーID
    const currentPage = ref(1); // 現在ページ
    const itemsPerPage = ref(20); // 1ページに表示する最大件数
    const txtSku = ref<HTMLInputElement | null>(null);
    const noticeMessages = ref<string[]>([]); // 注意文言メッセージリスト
    const productLinkUrl = ref(""); // 商品URL
    const downloadType = ref(ProductPriceCheckConstants.DOWNLOAD_TYPE_CSV); // ダウンロード形式
    // 検索条件の入力データ
    const inputData = ref<InputData>({
      sku: "",
      productName: "",
      deviceName: "",
    });
    // 検索結果のデータリスト
    const productPriceList = ref<ProductPriceData[]>([]);
    const isLoading = ref(false); // ブロッキングオーバーレイの表示フラグ
    const loadLines = ref<string[]>([]); // ブロッキングオーバーレイのメッセージ

    /**
     * AxiosErrorを処理します。
     * @param error エラー情報
     */
    const handleAxiosError = (error: unknown) => {
      errorMessage.value = commonHandleAxiosError(error, false);
    };

    /**
     * 初期処理
     */
    onMounted(async () => {
      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // 初期処理時はTrue
        isInitError.value = true;

        // ローカルストレージからユーザー情報を取得して内部変数に展開
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
        if (userInfo) {
          const parsedUserInfo = JSON.parse(userInfo);
          agCode.value = parsedUserInfo.agCode;
          userId.value = parsedUserInfo.userId;
          pseudoAgCode.value = parsedUserInfo.pseudoAgCode;
          pseudoUserId.value = parsedUserInfo.pseudoUserId;
          isKaunetAdmin.value =
            parsedUserInfo.isKaunet && parsedUserInfo.isAdmin;

          if (pseudoUserId.value == "") {
            // 疑似ログインIDが空の場合は、疑似ログインしていないとみなす
            serchUserId.value = userId.value;
            serchAgCode.value = agCode.value;
          } else {
            outputDebugLogs("疑似ログイン状態");
            serchUserId.value = pseudoUserId.value;
            serchAgCode.value = pseudoAgCode.value;
          }

          outputDebugLogs("管理者フラグ：" + parsedUserInfo.isKaunet);
          outputDebugLogs("カウネットフラグ：" + parsedUserInfo.isAdmin);
          outputDebugLogs("カウネット管理者：" + isKaunetAdmin.value);
        }

        // 初期表示データ取得API
        const response = await apiAuthClient.post(
          "/api/ProductPriceCheck/getInitialDisplayData",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
          }
        );

        // レスポンスからデータを取得
        const data = response.data;
        noticeMessages.value = data.noticeMessages;
        productLinkUrl.value = data.productLinkUrl;
        setTimeout(function () {
          // フォーカス設定
          if (txtSku.value) {
            txtSku.value.focus();
          }
        }, 1);

        isInitError.value = false;
        isDataFetched.value = true; // データが取得されたことを設定
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    });

    /**
     * クリアボタン押下
     */
    const onClear = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      processingStore.isProcessing = true;

      try {
        // メッセージクリア
        errorMessage.value = "";

        // 入力内容クリア
        inputData.value.sku = "";
        inputData.value.productName = "";
        inputData.value.deviceName = "";

        // 検索結果クリア
        productPriceList.value = [];

        setTimeout(function () {
          // フォーカス設定
          if (txtSku.value) {
            txtSku.value.focus();
          }
        }, 1);
      } finally {
        processingStore.isProcessing = false;
      }
    };

    /**
     * 検索ボタン押下
     */
    const onSerch = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      processingStore.isProcessing = true;

      try {
        errorMessage.value = "";

        // 入力チェック
        if (!validateInput()) {
          return;
        }

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        showLoading([
          "検索中です...",
          "画面を触らないでください",
          "検索条件によって時間がかかることがあります",
        ]);

        const sanitizedSku = sanitizeInput(inputData.value.sku);
        const sanitizedProductName = sanitizeInput(inputData.value.productName);
        const sanitizedDeviceName = sanitizeInput(inputData.value.deviceName);

        // 検索結果クリア
        productPriceList.value = [];

        // 商品価格情報一覧取得API実行
        const response = await apiAuthClient.post(
          "/api/ProductPriceCheck/getProductPriceList",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            sku: sanitizedSku,
            productName: sanitizedProductName,
            deviceName: sanitizedDeviceName,
          }
        );

        const data = response.data;
        productPriceList.value = data.productPriceList;

        // 先頭ページ表示
        currentPage.value = 1;

        if (response.data.searchResultCount === 0) {
          errorMessage.value = formatMessage(messages.WRN_0002, "商品");
          return;
        } else if (
          response.data.searchResultCount > response.data.maxSearchCount
        ) {
          errorMessage.value = formatMessage(
            messages.ERR_0044,
            response.data.maxSearchCount.toLocaleString("ja-JP")
          );
        }
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        processingStore.isProcessing = false;
        hideLoading();
      }
    };

    /**
     * ダウンロードボタン押下
     */
    const onDownload = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      processingStore.isProcessing = true;

      try {
        errorMessage.value = "";

        // 入力チェック
        const selectedCount = productPriceList.value.filter(
          (item) => item.selection
        ).length;
        if (selectedCount === 0) {
          errorMessage.value = formatMessage(messages.ERR_0042, "商品");
          return;
        }

        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // 商品価格情報出力API実行
        const response = await apiAuthClient.post(
          "/api/ProductPriceCheck/download/ProductPriceList",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            ProductPriceList: productPriceList.value
              .filter((item) => item.selection)
              .map((item) => ({
                sku: item.sku,
              })),
            downloadType: downloadType.value,
          },
          {
            responseType: "blob",
          }
        );

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;

        // サーバ側から返されたファイル名を取得
        const disposition = response.headers["content-disposition"];
        let fileName = "download.csv";
        if (disposition && disposition.includes("filename*=UTF-8")) {
          const matches = /filename\*=UTF-8''(.+)/.exec(disposition);
          if (matches && matches[1]) {
            fileName = decodeURIComponent(matches[1]);
          }
        }

        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        processingStore.isProcessing = false;
      }
    };

    /**
     * 入力チェック
     */
    const validateInput = (): boolean => {
      const messageList = ref<string[]>([]);

      // 使用不可文字チェック
      // 品番
      const sanitizedSku = sanitizeInput(inputData.value.sku);
      if (!hasNoGaiji(sanitizedSku)) {
        messageList.value.push(formatMessage(messages.ERR_0026, "品番"));
      }
      // 商品名
      const sanitizedProductName = sanitizeInput(inputData.value.productName);
      if (!hasNoGaiji(sanitizedProductName)) {
        messageList.value.push(formatMessage(messages.ERR_0026, "商品名"));
      }

      // 装置名
      const sanitizedDeviceName = sanitizeInput(inputData.value.deviceName);
      if (!hasNoGaiji(sanitizedDeviceName)) {
        messageList.value.push(formatMessage(messages.ERR_0026, "装置名"));
      }

      // いずれかの検索条件が入力されていること
      if (
        sanitizedSku === "" &&
        sanitizedProductName === "" &&
        sanitizedDeviceName === ""
      ) {
        messageList.value.push(messages.ERR_0043);
      }

      // 商品名：2文字以上入力されていない場合はエラー
      if (
        sanitizedProductName !== "" &&
        sanitizedProductName.replace(/[-\s]/g, "").length <
          ProductPriceCheckConstants.MIN_INPUT_LENGTH_PRODUCT_NAME
      ) {
        messageList.value.push(
          formatMessage(
            messages.ERR_0028,
            "商品名",
            ProductPriceCheckConstants.MIN_INPUT_LENGTH_PRODUCT_NAME.toString()
          )
        );
      }

      // 装置名：2文字以上入力されていない場合はエラー
      if (
        sanitizedDeviceName !== "" &&
        sanitizedDeviceName.replace(/[-\s]/g, "").length <
          ProductPriceCheckConstants.MIN_INPUT_LENGTH_DEVICE_NAME
      ) {
        messageList.value.push(
          formatMessage(
            messages.ERR_0028,
            "装置名",
            ProductPriceCheckConstants.MIN_INPUT_LENGTH_DEVICE_NAME.toString()
          )
        );
      }

      // エラーがある場合
      if (messageList.value.length > 0) {
        messageList.value.forEach((message, index) => {
          if (index > 0) {
            errorMessage.value += String.fromCharCode(10);
          }
          errorMessage.value += message;
        });
        return false;
      } else {
        errorMessage.value = "";
        return true;
      }
    };

    /**
     * ローディングオーバーレイの表示
     */
    const showLoading = (lines: string[]) => {
      loadLines.value = lines;
      isLoading.value = true;
    };

    /**
     * ローディングオーバーレイの非表示
     */
    const hideLoading = () => {
      isLoading.value = false;
      loadLines.value = [];
    };

    let prevOverflow = ""; // 元のオーバーフロースタイルを保存する変数
    /**
     * ローディングオーバーレイ表示中のスクロール制御
     */
    watch(isLoading, (v) => {
      if (v) {
        prevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = prevOverflow;
      }
    });

    /**
     * コンポーネントがアンマウントされる際にオーバーフローをリセット
     * - ローディングオーバーレイが表示されたままコンポーネントが破棄された場合でも、
     * - スクロールができなくなるのを防止するための措置
     */
    onBeforeUnmount(() => {
      document.body.style.overflow = prevOverflow;
    });

    /**
     * ページネーションのデータ生成
     */
    const paginatedData = computed(() => {
      const start = (currentPage.value - 1) * itemsPerPage.value;
      const end = start + itemsPerPage.value;
      return productPriceList.value.slice(start, end);
    });

    /**
     * 頁総数を取得
     */
    const totalPages = computed(() => {
      return Math.ceil(productPriceList.value.length / itemsPerPage.value);
    });

    /**
     * ページ切替ハンドラ
     */
    const handlePageChange = (page: number) => {
      currentPage.value = page;
    };

    /**
     * 全ページの選択件数をカウント
     */
    const selectedCount = computed(() => {
      return productPriceList.value.filter((item) => item.selection).length;
    });

    const formatCount = (value: number): string => {
      return `${value.toLocaleString("ja-JP")}件`;
    };

    type linkCell = { text: string; href: string | null };

    /**
     * URLリンク付きセルデータの構築
      - 価格改定日や終息予定日を表示する際に、URLがある場合はリンクとして表示し、URLがない場合はテキストのみを表示するための関数
      * @param date 日付
      * @param url URL
     */
    const buildLinkCellForDate = (
      date?: string,
      url?: string | null
    ): linkCell => {
      const d = (date ?? "").trim();
      const u = (url ?? "").trim();

      if (d && u) {
        // 日付もURLもある場合はそのまま返す
        return { text: d, href: u };
      }
      if (d && !u) {
        // 日付のみある場合は日付のみを返す
        return { text: d, href: null };
      }
      if (!d && u) {
        // URLのみある場合はURLのみを返す
        return { text: "○", href: u };
      }
      return {
        text: date || "",
        href: url || null,
      };
    };

    /**
     * 品番のセルデータの構築
      - 品番を表示する際に、URLがある場合はリンクとして表示し、URLがない場合はテキストのみを表示するための関数
     * @param sku 品番
     */
    const buildLinkCellForSku = (sku?: string | null): linkCell => {
      const s = (sku ?? "").trim();
      if (s) {
        // SKUがある場合はそのまま返す
        return { text: s, href: productLinkUrl.value.replace("{sku}", s) };
      }
      return {
        text: "",
        href: null,
      };
    };

    /**
     * 全ページの全選択/全クリアのトグル
     */
    const anySelectedInAllPage = computed(() => {
      return productPriceList.value.some((item) => item.selection);
    });

    /**
     * 全選択/全クリアのラベルを動的に切り替え
     */
    const selectHeaderLabel = computed(() => {
      return anySelectedInAllPage.value ? "全クリア" : "全選択";
    });

    /**
     * 現在ページの全選択/全クリアのトグル
     */
    const toggleSelectCurrentPage = () => {
      const newValue = !anySelectedInAllPage.value; // true=全選択 / false=全クリア
      productPriceList.value.forEach((item) => {
        item.selection = newValue;
      });
    };

    /**
     * 選択状態の切り替え
     * @param item 項目
     */
    const toggleSelection = (item: { selection: boolean }) => {
      item.selection = !item.selection;
    };

    return {
      isInitError,
      isDataFetched,
      errorMessage,
      isKaunetAdmin,
      noticeMessages,
      inputData,
      productLinkUrl,
      productPriceList,
      downloadType,
      ProductPriceCheckConstants,
      onClear,
      onSerch,
      onDownload,
      txtSku,
      currentPage,
      itemsPerPage,
      paginatedData,
      totalPages,
      handlePageChange,
      buildLinkCellForSku,
      buildLinkCellForDate,
      selectedCount,
      formatCount,
      anySelectedInAllPage,
      selectHeaderLabel,
      toggleSelectCurrentPage,
      toggleSelection,
      isLoading,
      loadLines,
    };
  },
});
</script>
<style scoped>
/* =====================================================================
   エラー表示
   ===================================================================== */
.errorform {
  margin-top: 50px;
  width: 100%;
  height: 500px;
  text-align: center;
}
/* =====================================================================
   管理画面 コンテンツエリア
   ===================================================================== */
/* タイトル・注意文言の下余白 */
.com_form_contet_admin .title_left,
.com_form_contet_admin .notice-messages {
  margin-bottom: 0.5rem;
}
/* =====================================================================
   検索条件エリア
   ===================================================================== */
/* 検索条件テーブル */
.com_form_contet_admin .cond-table {
  width: 100%;
  table-layout: fixed;
}
/* 条件ラベル（右寄せ・上揃え） */
.com_form_contet_admin .cond-control-title {
  vertical-align: top;
  text-align: right;
  padding-top: 5px;
  padding-right: 10px;
  white-space: nowrap;
}
/* 条件の補足テキスト（小文字・グレー） */
.com_form_contet_admin .cond-note {
  font-size: 0.8rem;
  color: #555;
  margin-top: 4px;
  white-space: nowrap;
}
/* ボタンエリアの横並びレイアウト */
.flex-container {
  display: flex;
  justify-content: space-between;
}
/* ダウンロード形式ラジオボタンの余白 */
.form-check-input[name="downloadType"] {
  margin: 0rem 0.2rem 0rem 0rem;
  vertical-align: inherit;
}
/* 検索・クリアボタン */
.form1 .cond-btn-footer {
  margin: 0.5rem 0.55rem;
  padding: 0.375rem 2rem;
  border-radius: 1rem;
  width: 140px;
  max-width: 140px;
  height: 40px;
  line-height: 1.2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
/* =====================================================================
   件数・ダウンロードエリア
   ===================================================================== */
/* 全体レイアウト（件数：左 / ダウンロード：右） */
.result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
/* 件数表示 */
.result-header .counts {
  display: flex;
  align-items: center;
  gap: 15px;
}
/* ダウンロードエリア（ラジオ＋ボタンの横並び） */
.result-header .download {
  display: flex;
  align-items: center;
}
/* ダウンロード形式ラジオグループ */
.result-header .radio-group {
  display: flex;
  align-items: center;
  gap: 10px;
}
.result-header .radio-item {
  display: inline-flex;
  gap: 10px;
  margin-right: 10px;
}
/* ダウンロードボタン */
.form1 .btn-download {
  margin: 0.5rem 0.5rem;
  padding: 0rem 0rem;
  border-radius: 1rem;
  width: 300px;
  max-width: 300px;
  height: 40px;
  line-height: 1.2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}
/* ダウンロードボタン内アイコン */
.form1 .btn-download .icon {
  display: inline-flex;
  line-height: 0;
}
/* 全選択 / 全クリアボタン（テーブルヘッダー内） */
.form1 .btn-select-header {
  width: 100%;
  max-width: 100%;
  height: 35px;
  min-height: 35px;
  margin: 0;
  padding: 0 4px;
  border-radius: 0.4rem;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font: inherit;
  font-size: 0.7rem;
  white-space: normal;
  word-break: keep-all;
}

/* =====================================================================
   検索結果テーブル
   ===================================================================== */
/* テーブルのスクロールラッパー */
.result-list {
  overflow: auto;
  max-width: 100%;
  position: relative;
  -webkit-overflow-scrolling: touch;
}
/* テーブル基本スタイル（border-collapse を separate にして sticky と共存） */
.result-list .result-table {
  table-layout: fixed;
  width: max-content;
  min-width: 100%;
  border-top: 1px solid #c5c5c5;
  border-right: 1px solid #c5c5c5;
  border-left: 0 !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
}
.result-list .result-table th {
  font-size: 0.7rem;
}
.result-list .result-table td {
  font-size: 0.55rem;
}
/* セル罫線（右・下のみ） */
.result-list .result-table th,
.result-list .result-table td {
  border-right: 0 !important;
  border-left: 1px solid #c5c5c5;
  border-bottom: 1px solid #c5c5c5;
}
/* データセル背景色 */
.result-list .result-table td {
  background-color: #fff;
}
/* ヘッダーセル背景色 */
.result-list .result-table thead th {
  background-color: lightgray;
}
/* ヘッダー行の文字揃え */
thead {
  text-align: center;
  vertical-align: middle;
}
/* データ行：テキスト省略（overflow + ellipsis） */
.tr-row-data td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 0;
}
/* =====================================================================
   固定列（sticky）―― 左3列（選択・品番・商品名）をスクロール時に固定
   ===================================================================== */
/* 【1】選択列の左端罫線：box-shadow で画面端の縦線が消えないよう対策
        ※ background は td 向けに #fff をセット（th は後続ルールで上書き） */
.result-list .result-table th.col_selection,
.result-list .result-table td.col_selection {
  background-color: #fff;
  border-left: 0 !important;
  box-shadow: inset 1px 0 0 0 #c5c5c5;
}
/* 【2】選択列ヘッダー：灰色背景を維持しつつ左罫線も確保 */
.result-list .result-table th.col_selection {
  background-color: lightgray;
  box-shadow: inset 1px 0 0 0 #c5c5c5;
}
/* 【3】固定列ヘッダーの背景色（灰色） */
.result-list .result-table th.col_selection,
.result-list .result-table th.col_sku,
.result-list .result-table th.col_productName {
  background-color: lightgray;
}
/* 【4】固定列データ行の背景色（白：スクロール時の透け防止） */
.result-list .result-table td.col_selection,
.result-list .result-table td.col_sku,
.result-list .result-table td.col_productName {
  background-color: #fff;
}
/* 【5】固定列の位置・幅 */
/* 1列目（選択列）：左端に固定 */
.result-list .result-table th.col_selection,
.result-list .result-table td.col_selection {
  position: sticky;
  left: 0;
  width: 60px;
  min-width: 60px;
  max-width: 60px;
}
/* 2列目（品番列）：選択列の直右に固定 */
.result-list .result-table th.col_sku,
.result-list .result-table td.col_sku {
  position: sticky;
  left: 60px;
  width: 68px;
  min-width: 68px;
  max-width: 68px;
}
/* 3列目（商品名列）：品番列の直右に固定。右端は box-shadow で疑似罫線 */
.result-list .result-table th.col_productName,
.result-list .result-table td.col_productName {
  position: sticky;
  left: 128px;
  width: 230px;
  min-width: 230px;
  max-width: 230px;
  border-right: 0 !important;
  box-shadow: 1px 0 0 0 #c5c5c5;
}
/* 【6】固定列の z-index（ヘッダー > データ行、左列 > 右列）
        ※ background も再セット（スクロール時の重なり順を確実に制御） */
.result-list .result-table th.col_selection {
  z-index: 60;
  background: lightgray;
}
.result-list .result-table th.col_sku {
  z-index: 59;
  background: lightgray;
}
.result-list .result-table th.col_productName {
  z-index: 58;
  background: lightgray;
}
.result-list .result-table td.col_selection {
  z-index: 40;
  background: #fff;
}
.result-list .result-table td.col_sku {
  z-index: 39;
  background: #fff;
}
.result-list .result-table td.col_productName {
  z-index: 38;
  background: #fff;
}

/* =====================================================================
   セルスタイル
   ===================================================================== */
/* 選択列のセル配置・余白 */
.result-table th.col_selection,
.result-table td.col_selection {
  text-align: center;
  vertical-align: middle;
  padding: 2px 4px !important;
  overflow: hidden;
}
/* チェックボックスセル */
.cell-checkbox {
  text-align: center;
  vertical-align: middle;
  transform: none;
  transform-origin: center;
}
.cell-checkbox input[type="checkbox"] {
  transform: scale(1.5);
  transform-origin: center;
}
/* 数値セル（右寄せ） */
.cell-number {
  text-align: right;
}
/* 日付セル（中央寄せ） */
.cell-date {
  text-align: center;
}
/* リンクの見た目 */
.link-url {
  color: blue;
  text-decoration: underline;
}
/* =====================================================================
   列幅定義
   ===================================================================== */
.col_selection {
  width: 60px;
  padding: 0;
}
.col_sku {
  width: 68px;
}
.col_productName {
  width: 230px;
}
.col_manufacturer {
  width: 88px;
}
.col_retailPrice {
  width: 74px;
}
.col_yourPrice {
  width: 74px;
}
.col_logisticsFee {
  width: 74px;
}
.col_total {
  width: 74px;
}
.col_s3Price {
  width: 74px;
}
.col_aPrice {
  width: 74px;
}
.col_bPrice {
  width: 74px;
}
.col_ePrice {
  width: 74px;
}
.col_priceRevision {
  width: 80px;
}
.col_endSchedule {
  width: 80px;
}
.col_deviceName {
  width: 300px;
}
.col_remarks {
  width: 300px;
}
</style>
